import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentNav: "index",
    // baseUrl:'http://192.168.0.41:8081', // 本地
    // fileUrlHeader:'http://192.168.0.41:8081',  // 本地
    baseUrl: 'http://www.wzhphg.com', // 线上
    fileUrlHeader: 'http://www.wzhphg.com',// 线上
  },
  mutations: {
    updateCurrentNav (state, val) {
      state.currentNav = val
    },
  },
  actions: {},
  modules: {},
})
